import * as Scrivito from "scrivito"

import { FeatureOverviewWidget } from "./FeatureOverviewWidgetClass"
import "./styles/_feature-overview-widget.scss"

Scrivito.provideComponent(FeatureOverviewWidget, ({ widget }) => {
  const showItems =
    Scrivito.isInPlaceEditingActive() || (widget.get("items")?.length ?? 0) > 0

  return (
    <section className="feature-overview-widget">
      <div className="feature-overview-widget__header">
        <Scrivito.ContentTag
          className="feature-overview-widget__title"
          content={widget}
          attribute="title"
        />

        <Scrivito.ContentTag
          className="feature-overview-widget__subtitle"
          content={widget}
          attribute="subtitle"
        />
      </div>

      {showItems ? (
        <Scrivito.ContentTag
          className="feature-overview-widget__items"
          tag="div"
          content={widget}
          attribute="items"
        />
      ) : null}
    </section>
  )
})
